// extracted by mini-css-extract-plugin
module.exports = {"modal":"BBRemoveModal_modal__3cQXb","close":"BBRemoveModal_close__VhQfE","buttons":"BBRemoveModal_buttons__1pPVs","button":"BBRemoveModal_button__12et8"};